import decorUnderline from "../utils/decor-underline";

function tabs() {
  const tabsContainer = Array.from(
    document.querySelectorAll(".tabs-container")
  );

  if (!tabsContainer) {
    return;
  }

  const mq = window.matchMedia("screen and (min-width:651px)");

  tabsContainer.forEach((tabContainer) => {
    const tabsTab = Array.from(tabContainer.querySelectorAll(".tabs-tab"));
    const indicator = tabContainer.querySelector(".tab-buttons__indicator");
    const multiLineTabs = tabContainer.querySelector(".tab-buttons--multiline");

    if( !multiLineTabs && indicator ) {
      decorUnderline(tabContainer, indicator);
      onresize = (event) => {
        decorUnderline(tabContainer, indicator);
      };

    }

    const contentAreas = Array.from(
      tabContainer.querySelectorAll(".tabs-content")
    );


    const currentTab = tabsTab.find(tab => tab.classList.contains("-current"));
    const currentTabData = currentTab.getAttribute("data-tab");
    const currentTabTarget = tabContainer.querySelector('.tabs-content[data-tab="' + currentTabData + '"]');
    contentAreas.forEach((contentArea) => {
      contentArea.classList.remove("-show");
    });
    currentTabTarget.classList.add("-show");

    // Check url for hash fragment. If there is one and it matches a tab, activate that tab
    const setTabBasedOnUrlHash = (tab) => {
      var hash = window.location.hash;
      if (hash == "") {
        return;
      }
      var _hash = hash.replace("#", "");
      tab.classList.remove("-current");
      var hashMatch = document.querySelector('[data-tab="' + _hash + '"]');
      hashMatch.classList.add("-current");
      // remove active from sibling matching content
      var matchedContent = document.querySelector(
        '.tabs-content[data-tab="' + _hash + '"]'
      );
      var matchedParent = matchedContent.parentElement;
      var matchedParentItems = Array.from(
        matchedParent.querySelectorAll("[data-tab]")
      );
      matchedParentItems.forEach((item) => {
        item.classList.remove("-show");
      });
      // Set matching content to active
      matchedContent.classList.add("-show");
    }; // end setTabBaedOnUrlHash

    tabsTab.forEach((tab) => {
      setTabBasedOnUrlHash(tab);

      if( !multiLineTabs && indicator ) {
        decorUnderline(tabContainer, indicator);
      }

      tab.addEventListener("click", (e) => {
        e.cancelBubble = true;

        tabsTab.forEach((tab) => {
          tab.classList.remove("-current");
        });

        tab.classList.add("-current");

        // set initial "current tab" indicator
        if( mq.matches && !multiLineTabs && indicator ) {
          decorUnderline(tabContainer, indicator);
        }

        const dataTab = tab.getAttribute("data-tab");
        const tabTarget = tabContainer.querySelector(
          '.tabs-content[data-tab="' + dataTab + '"]'
        );
        contentAreas.forEach((contentArea) => {
          contentArea.classList.remove("-show");
        });
        tabTarget.classList.add("-show");
      });
    }); // end foreach
  });
}

tabs();
